import { Component, OnInit } from '@angular/core';

import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FooterService } from '../../components/footer/footer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-saved-itinerary',
  templateUrl: './saved-itinerary.component.html',
  styleUrls: ['./saved-itinerary.component.css']
})
export class SavedItineraryComponent implements OnInit {
  userId: string = '';
  savedItineraryDataList: any = [];

  constructor(
    public storageService: StorageService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    private footerService: FooterService,
    private router: Router
  ) 
  { }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.userId = localStorage.getItem("_id");
    this.getSavedItinerarybyuserIdId();
  }

  goBack(): void {
    this.router.navigate(['profile']); 
  }

  toggleContent(index: number): void {
    this.savedItineraryDataList.forEach((item: any, i: number) => {
      item.isOpen = i === index ? !item.isOpen : false;
    });
  }

  getSavedItinerarybyuserIdId() {
    this.userLayoutService.getSavedItineraryById(this.userId).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.savedItineraryDataList = Response.data;
        // console.log("SavedItineraryDataList", this.savedItineraryDataList);
      }
      else {
        Response.error
      }
    }, (error) => {
      // console.log(error.error.Message);
    });
  }
}
